
import React, { useState, useContext } from 'react';
import AdminLayout from '../../components/admin-layout';
import { AppContext, ProfileSliderContext } from '../../appContext';
import ConsultationViewRequest from '../../components/ConsultationCard/ConsultationViewRequest';
import DesktopProfileMenuPage from '../../PageComponent/ProfilePage/DesktopProfileMenuPage';
import MobileProfileMenuPage from '../../PageComponent/ProfilePage/MobileProfileMenyPage';

function ProfileLayout() {
  const { loggedInUser } = useContext(AppContext);
  const [slider, setSlider] = useState(false);
  const [ViewRequestBlock, setViewRequestBlock] = useState(false);
  const [currentrequest, setcurrentrequest] = useState(null);
  const [profileData, setprofileData] = useState(null);
   const handelSlider = () => {
      setSlider(!slider);
    };
  function handelViewRequestBlock(data, proData) {
    setViewRequestBlock(!ViewRequestBlock);
    console.log('consultdata', data?._id);
    setcurrentrequest(data?._id);
    setprofileData(proData);
  }
  
  return (
    <>
      <ProfileSliderContext.Provider
         value={{
    slider,
    setSlider,
    handelViewRequestBlock,
  }}
      >
        <section>
          <section className='hidden lg:block'>
          <AdminLayout headerTxt={'Settings'}>
            <DesktopProfileMenuPage loggedInUser={loggedInUser} />
          </AdminLayout>
          </section>
          <section className='lg:hidden'>
            <MobileProfileMenuPage 
            loggedInUser={loggedInUser}
            handelSlider={()=>{handelSlider()}}
            />
          </section>
          {ViewRequestBlock && (
              <ConsultationViewRequest
                closeFunction={handelViewRequestBlock}
                currentdata={currentrequest}
                profileData={profileData}
                navigatedFromNotification={false}
              />
            )}
        </section>
      </ProfileSliderContext.Provider>
    </>
  );
}

export default ProfileLayout;
